import React, { useEffect } from "react";
import "./Gallery.css";
import arrow from "../../assets/products/arrow.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useParams } from "react-router-dom";
import listOfImages from "../../helpers/images";
import { useNavigate } from "react-router-dom";

const Gallery = () => {
  const { listId } = useParams();
  let index = listId.charAt(listId.length - 1);
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init();
    const scrollOneScreenDown = () => {
      const screenWidth = window.innerWidth;
      const isLargeScreen = screenWidth > 768;
      if (isLargeScreen) {
        const screenHeight = window.innerHeight * 0.9;
        const scrollPosition = screenHeight;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    };
    scrollOneScreenDown();
  }, []);

  let dataList = listOfImages[listId];
  const handleViewProduct = (e) => {
    e.preventDefault();
    if (Object.keys(listOfImages).length !== parseInt(index)) {
      navigate(`/gallery/project${parseInt(index) + 1}`);
    } else {
      navigate(`/gallery/project1`);
    }
  };
  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Our Gallery</h1>
      <div className="gallery" id="gallery">
        {dataList.map((data, dataIndex) => {
          if (dataIndex !== dataList.length - 1)
            return (
              <div className="g_container" key={dataIndex}>
                <img src={data} alt="metal" className="g_image" />
              </div>
            );
          else
            return (
              <div className="g_last-container" key={dataIndex}>
                <img
                  src={data}
                  alt="metal"
                  className="g_image g_image-opacity"
                />
                <div
                  onClick={(e) => handleViewProduct(e)}
                  className="gallery-absolute"
                >
                  VIEW ALL <br />
                  PRODUCTS
                  <img src={arrow} alt="..." className="arrow-image" />
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default Gallery;
